import { jsxs, jsx } from "react/jsx-runtime";
import { Image as Image$1 } from "@zillow/constellation";
import { withPreload, Figure } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import React from "react";
import { pickAnimationDomProps } from "../../components/BlockAnimation/animationConfig.esm.js";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import StructuredData from "../../components/StructuredData/StructuredData.esm.js";
import { withAnchor } from "../../util/helpers.esm.js";
const ImagePreload = withPreload(Image$1);
const BlockImage = ({
  attrs,
  index
}) => {
  const {
    alt,
    caption,
    src,
    width,
    height,
    loading = "lazy",
    decoding = "async",
    sizes,
    srcSet,
    margin
  } = attrs;
  const structuredData = {
    "@context": "https://schema.org/",
    "@type": "ImageObject",
    contentUrl: src,
    caption: alt,
    height,
    width
  };
  const isPost = usePlacement() === "post";
  return /* @__PURE__ */ jsxs(React.Fragment, { children: [
    /* @__PURE__ */ jsx(StructuredData, { data: structuredData }),
    /* @__PURE__ */ jsxs(Figure, { ...isPost ? {
      marginBottom: "md"
    } : margin, ...pickAnimationDomProps(attrs), children: [
      /* @__PURE__ */ jsx(
        ImagePreload,
        {
          src,
          alt,
          width,
          height,
          loading,
          decoding,
          srcSet,
          sizes
        },
        index
      ),
      caption && /* @__PURE__ */ jsx(Figure.Caption, { children: caption })
    ] })
  ] });
};
BlockImage.propTypes = {
  attrs: PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    src: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    loading: PropTypes.string
  }),
  index: PropTypes.number
};
const Image = withAnchor(BlockImage);
export {
  Image as default
};
